import { render } from "./Home.vue?vue&type=template&id=2db56c2a&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=2db56c2a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2db56c2a"

export default script